<template>
  <div class="page">
    <h2>Hey, I'm Yuri!</h2>
    <p>
      Nice to meet you! Heres some info about me! Enjoy! 😁. 
    </p>
    <ul>
      <li>
        I am 14 years old
      </li>
      <li>
        I am awesome!
      </li>
      <li>
        I am a good person lol
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>



</style>